module.exports = __webpack_public_path__ + "img/icon.629cab12.svg";